import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import EmailTipsStore from '@src/business-components/appointment-modal/overseas/components/email-tips/store';
import cx from 'classnames';

const styles = require('./index.less');

/**
 *
 * @param store {EmailTipsStore}
 * @param className {string}
 * @return {JSX.Element}
 * @constructor
 */
const EmailTips = ({ store, className }) => {
  store.use();
  if (!store.active) {
    return null;
  }
  return (
    <div className={cx(styles.root, className)} ref={store.listRef}>
      {store.emailList.map((item, key) => (
        <div className={cx(styles.list, store.num === key && styles.current)} key={key} onClick={e => store.onClick(item.value)}>
          {item.label}
        </div>
      ))}
    </div>
  );
};

export default wrapStore(EmailTips, EmailTipsStore);
